var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { disabled: _vm.disabled } }, [
    _c(
      "div",
      {
        staticClass: "item-container",
        class: { disabled: _vm.disabled },
        on: {
          click: function($event) {
            return _vm.$emit("execute")
          }
        }
      },
      [
        _vm._t("default"),
        _vm._v(" "),
        _c("div", { staticClass: "text-container" }, [
          _vm._v(_vm._s(_vm.action))
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-320599a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-320599a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectMenu/ObjectMenuItem.vue
// module id = null
// module chunks = 